import React from 'react';
import Loader from 'react-loader-spinner';

export default function LoaderStatus() {
    return (
        <div className="table-footer text-center">
            <Loader
                type="ThreeDots"
                color="#343A40"
                height={100}
                width={100}
                visible={true}
            />
        </div>
    )
}

